<template>
	<div class="nk-stabs d-flex flex-column">
		<ul class="nav nav-tabs" tabscope :tabindex="tabindex" ref="tabul" :startup="startup ? true : null" @focus="onFocus">
			<li v-for="(tab, i) in tabs" :key="tab.id" class="nav-item" :tabindex="i + 1">
				<a v-if="tab.closable" @click="closeTab(tab.id)" class="nav-close"><i class="fal fa-times"></i></a>
				<a @click="selectTab(tab.id, $event)" class="nav-link" :class="{ 'active': tab.isActive, 'disabled': tab.isDisabled }" v-html="tab.name" href="javascript:void(0)"></a>
			</li>
		</ul>
		<div :class="{ 'nk-stabs-panels': true, 'scrollable': scrollable }" ref="tabs-panel">
			<slot />
		</div>
	</div>
</template>
<script>
	import $ from 'jquery'

	export default {
		name: 'stab-host',
		props: {
			tabKeys: { type: Array, default: [] },
			activeTab: { default: '' },
			tabindex: { type: Number, default: () => 1 },
			scrollable: { type: Boolean, default: false },
			startup: { type: Boolean }
		},
		emits: ['activeTabChanged', 'closeClicked'],
		data() {
			return {
				tabs: [],
				currentTab: null
			}
		},
		watch: {
			tabs: {
				deep: true,
				handler(value, oldValue) {
					this.defer(this.subscribeKeys, 1)
				}
			},
			activeTab: {
				handler(value, oldValue) {
					if (value != this.currentTab)
						this.selectTab(value)
				}
			},
			tabKeys: {
				handler(value, oldValue) {
					this.tabs = this.tabs.filter(t => (value || []).indexOf(t.id) > -1)
					if (value.length && value.indexOf(this.activeTab) === -1) {
						this.$nextTick(() => {
							this.selectTab(value[value.length - 1])
						})
					}
				}
			}
		},
		computed: {
		},
		created() {
		},
		mounted() {
			if (this.tabs.length > 0) {
				if (this.activeTab !== '') {
					this.selectTab(this.activeTab)
				} else {
					this.selectTab(this.tabs[0].id)
				}
			}
		},
		methods: {
			onFocus() {
				// this.focusTab()
			},

			findTab(id) {
				return this.tabs.find(tab => tab.id === id)
			},
			closeTab(tabId) {
				this.$emit('closeClicked', tabId)
			},
			selectTab(selectedTabId, event) {
				if (typeof event !== 'undefined') {
					event.preventDefault()
				}

				const selectedTab = this.findTab(selectedTabId)

				if (!selectedTab) {
					return
				}

				if (selectedTab.isDisabled) {
					return
				}

				this.tabs.forEach(tab => {
					tab.isActive = (tab.id === selectedTab.id)
				})

				this.currentTab = selectedTab.id
				this.$emit('activeTabChanged', selectedTab.id)

				// if event != undefined then this called by an click or keydown event
				if (typeof event !== 'undefined') {
					this.focusTab()
				}
			},
			setTabVisible(id, visible) {
				const tab = this.findTab(id)

				if (!tab) {
					return
				}

				tab.isVisible = visible

				if (tab.isActive) {
					// If tab is active, set a different one as active.
					tab.isActive = visible

					this.tabs.every((tab, index, array) => {
						if (tab.isVisible) {
							tab.isActive = true

							return false
						}

						return true
					})
				}
			},
			focusTab() {
				var that = this
				setTimeout(() => {
					var tabItems = $(that.$refs['tabs-panel']).find('section:visible [tabindex]').map(function (index, item) {
						return {
							tabindex: parseInt(item.attributes.tabindex.value),
							el: item
						}
					})

					if (tabItems.length > 0) {
						var min = tabItems[0]

						for (var i = 1; i < tabItems.length; i++) {
							if (tabItems[i].tabindex > 0 && tabItems[i].tabindex < min.tabindex) {
								min.el = tabItems[i].el
							}
						}

						if (min.el != null) {
							$(min.el).focus()
						}
					}
				}, 5)
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: `stab-open-tab`,
					keyCode: 32, // 32:space
					el: $(this.$refs.tabul).find('> li.nav-item'),
					context: this,
					handler: function (sender, e) {
						e.preventDefault()

						var index = $(this.$refs.tabul).find('> li.nav-item').index(sender)
						if (index > -1) {
							e.preventDefault()

							var tab = this.tabs[index]
							this.selectTab(tab.id, e)
						}
					}
				})
			}
		}
	}
</script>
<style lang="less">
	.nk-stabs .nav-tabs {
		padding-right: 0;

		.nav-close {
			cursor: pointer;
			position: absolute;
			left: 3px;
		}

		.nav-item {
			position: relative;
		}
	}

	.nk-stabs-panels {
		padding: 10px;
		border: 1px solid #dee2e6;
		border-top: none;
	}

	.tabs-no-padding .nk-stabs-panels {
		padding: 0 !important;
	}
</style>
